import { createReducer } from 'reduxsauce';
import { Types } from './actions';

const INITIAL_STATE = {
  loading: false,
  t3BannerData: null,
  latestT3: null,
  pageForLatestT3: 1
};

// *************************** Fetch T3 Banner ****************************
const fetchT3BannerStart = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchT3BannerSuccess = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    t3BannerData: action.t3BannerData,
    loading: false
  };
};

const fetchT3BannerFailure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// ************************* Fetch Latest T3 *************************
const fetchLatestT3Start = (state = INITIAL_STATE, action) => {
  return { ...state, loading: true };
};

const fetchLatestT3Success = (state = INITIAL_STATE, action) => {
  let latestT3 = [];
  if (state.latestT3 === null && action.latestT3.pageNumber === 1) {
    latestT3 = action.latestT3.latestT3;
  } else if (action.latestT3.pageNumber === 1) {
    latestT3 = [...state.latestT3];
  } else {
    latestT3 = [...state.latestT3, ...action.latestT3.latestT3];
  }

  return {
    ...state,
    latestT3: latestT3,
    pageForLatestT3: state.pageForLatestT3 + 1,
    loading: false
  };
};

const fetchLatestT3Failure = (state = INITIAL_STATE, action) => {
  return { ...state, loading: false };
};
// _____________________________________________________________________

// Define Handlers
const HANDLERS = {
  [Types.FETCH_T3_BANNER_START]: fetchT3BannerStart,
  [Types.FETCH_T3_BANNER_FAILURE]: fetchT3BannerFailure,
  [Types.FETCH_T3_BANNER_SUCCESS]: fetchT3BannerSuccess,

  [Types.FETCH_LATEST_T3_START]: fetchLatestT3Start,
  [Types.FETCH_LATEST_T3_FAILURE]: fetchLatestT3Failure,
  [Types.FETCH_LATEST_T3_SUCCESS]: fetchLatestT3Success
};

// Create and Export Reducer
export const t3Reducer = createReducer(INITIAL_STATE, HANDLERS);
